import { useDispatch, useSelector } from "react-redux";
import { UserIcon } from "../../../../../assets/common-svg/CommonSvg";
import { dateFormater } from "../../../../utils/common/utils";
import { changeFollowCycle, selectFollowCycle } from "../../../../slices/common";
import { useEffect, useMemo, useRef, useState } from "react";
import { Box, InputLabel } from "@mui/material";
import ListAssignedPM from "../../../../../pages/appointment-details/common-in-bound/listAssignPM"
import { useNavigate } from "react-router";

const PatientDetails = ({patientInfo, patientData,subjectData=[], cycleData = [] }) => {
  const dispatch = useDispatch();
  const currentCycle = useSelector(selectFollowCycle);
  const [editorDrawerData, setEditorDrawerData] = useState([]);
  const [openEditorDrawer, setOpenEditorDrawer] = useState(false);
  const LoginData = useSelector((state) => state.loginData);
  const role_slug = LoginData.role_slug;
  const [selectedCycleIndex, setSelectedCycleIndex] = useState(0);
  const initialized = useRef(false);
  const navigate = useNavigate();

     const buildAssigneeList = (data) => {
    const list = [];
       if (data?.userPi?.length) {
      data.userPi.forEach((pi) => {
        list.push({
          id: pi.id,
          name: pi.name,
          role: pi.role_title,
        });
      });
    }
    return list;
  };



  /* ---------- Prepare cycles ---------- */
  const cycles = useMemo(() => {
    if (!Array.isArray(cycleData)) return [];
    return cycleData.map((cyc, index) => ({
      label: cyc?.cycle,
      value: index
    }));
  }, [cycleData]);

  /* ---------- Initial default cycle (latest) ---------- */
  useEffect(() => {
    if (!cycleData.length || initialized.current) return;

    const lastIndex = 0;

    setSelectedCycleIndex(lastIndex);
    dispatch(
      changeFollowCycle({
        index: lastIndex,
        cycle: cycleData
      })
    );

    initialized.current = true;
  }, [cycleData, dispatch]);

  /* ---------- Redux → local sync ---------- */
  useEffect(() => {
    if (
      typeof currentCycle?.index === "number" &&
      currentCycle.index !== selectedCycleIndex
    ) {
      setSelectedCycleIndex(currentCycle.index);
    }
  }, [currentCycle?.index]);

  
 const handleOpenEditorDrawer = () => {
  const list = buildAssigneeList(subjectData);
  setEditorDrawerData(list);
  setOpenEditorDrawer(true);
};

  /* ---------- User change ---------- */
  const handleCycleChange = (e) => {
    const index = Number(e.target.value);

    setSelectedCycleIndex(index);
    dispatch(
      changeFollowCycle({
        index,
        cycle: cycleData
      })
    );
  };

  const handleVisitUrl = () =>{
  const routes = {
    "editor": `/phases/phase-details/${patientInfo?.phase_id}/patient-details/${patientInfo?.id}/inbound-form/${currentCycle?.qr_code_generation_id || patientInfo?.qr_code_id}`,
    "project-manager": `/phases/phase-details/${patientInfo?.phase_id}/patient-details/${patientInfo?.id}/inbound-form/${currentCycle?.qr_code_generation_id || patientInfo?.qr_code_id}`,
    "superadmin":currentCycle?.feasibility_assessments_id ? `/bmr/logistics-management/in-bound/view/${currentCycle?.qr_code_generation_id || patientInfo?.qr_code_id}/${currentCycle?.feasibility_assessments_id}`:`/phases/phase-details/${patientInfo?.phase_id}/patient-details/${patientInfo?.id}/inbound-form/${currentCycle?.qr_code_generation_id || patientInfo?.qr_code_id}`,
    "quality-check": `/bmr/qc/${currentCycle?.qr_code_generation_id || patientInfo?.qr_code_id}/${currentCycle?.feasibility_assessments_id}`,
    "logistics-management": `/bmr/logistics-management/in-bound/view/${currentCycle?.qr_code_generation_id || patientInfo?.qr_code_id}/${currentCycle?.feasibility_assessments_id}`,
    "warehouse":  `/bmr/logistics-management/in-bound/view/${currentCycle?.qr_code_generation_id || patientInfo?.qr_code_id}/${currentCycle?.feasibility_assessments_id}`,
    "manufacture-lead":  `/bmr/manufacturer_view/${currentCycle?.qr_code_generation_id || patientInfo?.qr_code_id}/${currentCycle?.feasibility_assessments_id}`,
    "manufacture": `/bmr/manufacturer_view/${currentCycle?.qr_code_generation_id || patientInfo?.qr_code_id}/${currentCycle?.feasibility_assessments_id}`,
    "qc-lead":  `/bmr/qc/${currentCycle?.qr_code_generation_id || patientInfo?.qr_code_id}/${currentCycle?.feasibility_assessments_id}`,
    "quality-associate": `/bmr/qa/${currentCycle?.qr_code_generation_id || patientInfo?.qr_code_id}/${currentCycle?.feasibility_assessments_id}`,

  };
  navigate(routes?.[role_slug] ||  `/bmr/lsm/details/${currentCycle?.qr_code_generation_id || patientInfo?.qr_code_id}`);
}

  return (
    <div className="bg-white rounded-xl p-4 sm:p-6 mt-4 shadow-sm">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-20 h-20 rounded-full bg-blue-50 flex items-center justify-center">
          <UserIcon />
        </div>
        <div>
          <div className="text-xs text-gray-500">
            {patientData?.patient_information?.immunoact_patient_id || "- -"}
          </div>
          <div className="text-lg font-semibold">
            {patientData?.patient_information?.name || "- -"}
          </div>
           {patientInfo?.qr_code_id && ['editor','project-manager','superadmin']?.includes(role_slug) && <a
    className="font-medium  hover:text-blue-800 underline hover:underline cursor-pointer textModifyColor"
                        onClick={() => handleVisitUrl()}
                      >Visit Vein-To-Vein</a>}
        </div>
                    
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
        <DetailItem label="Patient Id" value={patientData?.patient_information?.immunoact_patient_id} />
        <DetailItem label="Product" value={patientData?.product_name} />
        <DetailItem label="Patient Status" value={patientData?.life_status} />
        <DetailItem label="Hospital Name" value={patientData?.hospital_name} />
        <DetailItem label="Editor/Project Manager" value={(() => {
          const editors = subjectData?.userPi || [];
          return editors.length > 1 
            ? editors.length.toString() 
            : (editors.length === 1) 
              ? editors[0]?.name || "--" 
              : "--";
        })()}
         action={true} onClick={handleOpenEditorDrawer}/>
        <DetailItem label="Principal Investigator" value={patientData?.principal_investigator} />
        <DetailItem label="Phase" value={patientData?.phase_name} />
        <DetailItem
          label="Date Of Birth"
          value={
            patientData?.patient_information?.dob
              ? dateFormater(patientData?.patient_information?.dob)
              : ""
          }
        />
        <ListAssignedPM  
        openEditorDrawer={openEditorDrawer}
        setOpenEditorDrawer={setOpenEditorDrawer}
        editorDrawerData={editorDrawerData} />
        <Box>
          <InputLabel>Select Cycle</InputLabel>
          <select
            value={selectedCycleIndex}
            onChange={handleCycleChange}
            className="w-full border rounded-md px-3 py-2 text-sm"
          >
            {cycles.map((cycle) => (
              <option key={cycle.value} value={cycle.value}>
                {cycle.label}
              </option>
            ))}
          </select>
        </Box>
      </div>
    </div>
  );
};

const DetailItem = ({ label, value, action = false, onClick }) => {
  return (
    <div>
      <div className="text-xs text-gray-500">{label}</div>
      {action ? (
        <button
          onClick={onClick}
          className="text-sm font-medium text-blue-600 hover:text-blue-800 hover:underline cursor-pointer text-left"
        >
          {value || "- -"}
        </button>
      ) : (
        <div className="text-sm font-medium">{value || "- -"}</div>
      )}
    </div>
  );
};

export default PatientDetails;



